import HttpRequest from "@/plugins/axios";

class PageProvider extends HttpRequest {
    constructor() {
        super(process.env.VUE_APP_API_URL);
    }

    async getPageStatus(uid) {
        const { data } = await this.get("/", {
            function: "get-page-status",
            uid,
        });
        return data;
    }
    async getPage1(uid) {
        const { data } = await this.get("/", {
            function: "get-page-1",
            uid,
        });
        return data;
    }
    async getPage2(uid) {
        const { data } = await this.get("/", {
            function: "get-page-2",
            uid,
        });
        return data;
    }
    async getPage3_1(uid) {
        const { data } = await this.get("/", {
            function: "get-page-3-1",
            uid,
        });
        return data;
    }
    async getPage3_2(uid) {
        const { data } = await this.get("/", {
            function: "get-page-3-2",
            uid,
        });
        return data;
    }
    async getPageFather(uid) {
        const { data } = await this.get("/", {
            function: "get-page-4",
            uid,
        });
        return data;
    }
    async getPageMother(uid) {
        const { data } = await this.get("/", {
            function: "get-page-5",
            uid,
        });
        return data;
    }
    async getPageParent(uid) {
        const { data } = await this.get("/", {
            function: "get-page-6",
            uid,
        });
        return data;
    }
    async getPage7(uid) {
        const { data } = await this.get("/", {
            function: "get-page-7",
            uid,
        });
        return data;
    }
    async getPageKMITL1(uid, student_id) {
        const { data } = await this.get("/", {
            function: "get-page-kmitl1",
            uid,
            student_id
        });
        return data;
    }
    async setPage1(info) {
        const { data } = await this.update("/", {
            function: "save-page-1",
            uid: info.uid,
            GENDER_ID: info.GENDER_ID,
            PREFIX_NAME_ID: info.PREFIX_NAME_ID,
            STUDENT_FNAME_EN: info.STUDENT_FNAME_EN,
            STUDENT_MNAME_EN: info.STUDENT_MNAME_EN,
            STUDENT_LNAME_EN: info.STUDENT_LNAME_EN,
        });
        return data;
    }
    async setPage2(info) {
        const { data } = await this.update("/", {
            function: "save-page-2",
            uid: info.uid,
            BIRTHDAY: info.BIRTHDAY,
            EMAIL: info.EMAIL,
            MOBILE: info.MOBILE,
            NATION_ID: info.NATION_ID,
            RACE_ID: info.RACE_ID,
            RELIGION_ID: info.RELIGION_ID,
            TALENT_ID: info.TALENT_ID,
            CITIZEN_ID_CARD_ISSUE_DATE: info.CITIZEN_ID_CARD_ISSUE_DATE,
            CITIZEN_ID_CARD_EXPIRY_DATE: info.CITIZEN_ID_CARD_EXPIRY_DATE,
            home: JSON.stringify(info.home),
            contact: JSON.stringify(info.contact),
            PASSPORT_NUMBER: info.PASSPORT_NUMBER,
            PASSPORT_STARTDATE: info.PASSPORT_STARTDATE,
            PASSPORT_ENDDATE: info.PASSPORT_ENDDATE,
            DISABILITY_ID: info.DISABILITY_ID,
            DEFORMCARD_ID: info.DEFORMCARD_ID,
            DEFORMCARD_STARTDATE: info.DEFORMCARD_STARTDATE,
            DEFORMCARD_ENDDATE: info.DEFORMCARD_ENDDATE,
            HOUSE_ID: info.HOUSE_ID,
            HOUSE_NUMBER: info.HOUSE_NUMBER,
            VILLAGE_NAME: info.VILLAGE_NAME,
            MOO: info.MOO,
            SOI: info.SOI,
            STREET: info.STREET,
            SUB_DISTRICT_ID: info.SUB_DISTRICT_ID,
        });
        return data;
    }
    async setPage3_1(info) {
        const { data } = await this.update("/", {
            function: "save-page-3-1",
            uid: info.uid,
            SCHOOL_TYPE_ID: info.SCHOOL_TYPE_ID,
            EDUCATION_NATION: info.EDUCATION_NATION,
            SCHOOL_GRAD_DATE: info.SCHOOL_GRAD_DATE,
            EDUCATION_TYPE_ID: info.EDUCATION_TYPE_ID,
            GPA: info.GPA,
            SCHOOL_STUDENT_ID: info.SCHOOL_STUDENT_ID,
            SCHOOL_NAME: info.SCHOOL_NAME,
            OLD_KMITL_STUDENT_ID: info.OLD_KMITL_STUDENT_ID,
            SCHOOL_ID: info.SCHOOL_ID,
        });
        return data;
    }
    async setPage3_2(info) {
        const { data } = await this.update("/", {
            function: "save-page-3-2",
            uid: info.uid,
            EDUCATION_NATION: info.EDUCATION_NATION,
            FACULTY_NAME: info.FACULTY_NAME,
            CURRICULUM_NAME: info.CURRICULUM_NAME,
            YEAR: info.YEAR,
            GPA: info.GPA,
            UNIVERSITY_ID: info.UNIVERSITY_ID,
            UNIVERSITY_NAME: info.UNIVERSITY_NAME,
        });
        return data;
    }
    async setPageFather(info) {
        const { data } = await this.update("/", {
            function: "save-page-4",
            uid: info.uid,
            PREFIX_NAME_ID: info.PREFIX_NAME_ID,
            PARENT_FNAME_TH: info.PARENT_FNAME_TH,
            PARENT_MNAME_TH: info.PARENT_MNAME_TH,
            PARENT_LNAME_TH: info.PARENT_LNAME_TH,
            // PARENT_FNAME_EN: info.PARENT_FNAME_EN,
            // PARENT_MNAME_EN: info.PARENT_MNAME_EN,
            // PARENT_LNAME_EN: info.PARENT_LNAME_EN,
            VITAL_STATUS_ID: info.VITAL_STATUS_ID,
            CITIZEN_ID: info.CITIZEN_ID,
            PASSPORT_NUMBER: info.PASSPORT_NUMBER,
            MOBILE: info.MOBILE,
            REVENUE_ID: info.REVENUE_ID,
            OCCUPATION_ID: info.OCCUPATION_ID,
            address_type: info.address_type,
            other_address: JSON.stringify(info.other_address),

        });
        return data;
    }
    async setPageMother(info) {
        const { data } = await this.update("/", {
            function: "save-page-5",
            uid: info.uid,
            PREFIX_NAME_ID: info.PREFIX_NAME_ID,
            PARENT_FNAME_TH: info.PARENT_FNAME_TH,
            PARENT_MNAME_TH: info.PARENT_MNAME_TH,
            PARENT_LNAME_TH: info.PARENT_LNAME_TH,
            // PARENT_FNAME_EN: info.PARENT_FNAME_EN,
            // PARENT_MNAME_EN: info.PARENT_MNAME_EN,
            // PARENT_LNAME_EN: info.PARENT_LNAME_EN,
            VITAL_STATUS_ID: info.VITAL_STATUS_ID,
            CITIZEN_ID: info.CITIZEN_ID,
            PASSPORT_NUMBER: info.PASSPORT_NUMBER,
            MOBILE: info.MOBILE,
            REVENUE_ID: info.REVENUE_ID,
            OCCUPATION_ID: info.OCCUPATION_ID,
            address_type: info.address_type,
            other_address: JSON.stringify(info.other_address),
        });
        return data;
    }
    async setPageParent(info) {
        const { data } = await this.update("/", {
            function: "save-page-6",
            uid: info.uid,
            parent_type: info.parent_type,
            PAR_RELATIVE_ID: info.PAR_RELATIVE_ID,
            PAR_STATUS_ID: info.PAR_STATUS_ID,
            PREFIX_NAME_ID: info.PREFIX_NAME_ID,
            PARENT_FNAME_TH: info.PARENT_FNAME_TH,
            PARENT_MNAME_TH: info.PARENT_MNAME_TH,
            PARENT_LNAME_TH: info.PARENT_LNAME_TH,
            // PARENT_FNAME_EN: info.PARENT_FNAME_EN,
            // PARENT_MNAME_EN: info.PARENT_MNAME_EN,
            // PARENT_LNAME_EN: info.PARENT_LNAME_EN,
            VITAL_STATUS_ID: info.VITAL_STATUS_ID,
            CITIZEN_ID: info.CITIZEN_ID,
            PASSPORT_NUMBER: info.PASSPORT_NUMBER,
            MOBILE: info.MOBILE,
            REVENUE_ID: info.REVENUE_ID,
            OCCUPATION_ID: info.OCCUPATION_ID,
            address_type: info.address_type,
            other_address: JSON.stringify(info.other_address),
        });
        return data;
    }
    async setPage7(info) {
        const { data } = await this.update("/", {
            function: "save-page-7",
            uid: info.uid,
            checked: info.checked,
        });
        return data;
    }
}

export default PageProvider;
